import React, { useEffect, useState } from 'react'
import { ButtonBack, ButtonNext, CarouselProvider, Slide, Slider } from 'pure-react-carousel'
import 'pure-react-carousel/dist/react-carousel.es.css'
import { withTheme } from 'theming'
import { isEmpty } from 'lodash'
import useTemplateHook from '../templateHook'
import EditMenu from '../editMenu'
import useAxios from 'axios-hooks'
import AddSection from '../addSection'
import './newSwimlane.css'
import LoaderTile from '../../contentCard/loaderTile'
import CustomImage from '../../customImage/customImage'

const HoverPeekCarousel = ({
  componentData,
  modifyData,
  setModalState,
  isEdit = true,
  onDelete,
  onSwap,
  onCopy,
  theme,
  onAdd,
}) => {
  const { data, id } = componentData
  const [hoverState, setHoverState] = useState('')
  const [hoverIndex, setHoverIndex] = useState('')

  const {
    customNavigate,
    LG_SIZE,
    SM_SIZE,
    CONTENT_FILTER_XAVIER,
    PortraitDummyImg,
    getTemplateImage,
    playerPageAllowed,
    isBrowser,
    KalingoLeftArrow,
    KalingoRightArrow,
  } = useTemplateHook()
  const [visibleSlides, setVisibleSlides] = useState(2)
  const [contentData, setContentData] = useState([])
  const language = localStorage.getItem('language') || 'en'

  const [{ data: contentList, loading: contentListLoading }, contentListCall] = useAxios(
    {
      url: CONTENT_FILTER_XAVIER,
      method: 'post',
    },
    { manual: true },
  )

  const handleResize = () => {
    if (window.innerWidth >= LG_SIZE) {
      setVisibleSlides(5.5)
    } else if (window.innerWidth < LG_SIZE && window.innerWidth >= SM_SIZE) {
      setVisibleSlides(3)
    } else {
      setVisibleSlides(2)
    }
  }

  useEffect(() => {
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    if (!isEmpty(data.content_data) || !isEmpty(data.auto_payload)) {
      let filterPayload =
        data.type === 'STATIC'
          ? { content_ids: data.content_data }
          : {
              system_defined: data.auto_payload.filter((info) => info.type === 'system_defined'),
              custom_defined: data.auto_payload.filter((info) => info.type === 'custom_defined'),
              video_types: ['SPV', 'MPVP', 'MPVC', 'LIVE', 'VOD_LIVE', 'PLAYLIST'],
            }

      contentListCall({
        data: {
          filters: filterPayload,
          page: 1,
          order_by:
            data.type === 'STATIC'
              ? ''
              : data?.order_by === 'title'
              ? `title.${language}`
              : data?.order_by,
          reverse: data.type === 'STATIC' ? '' : data?.reverse,
          page_size: 15,
        },
      })
    } else {
      setContentData([])
    }
  }, [data])

  useEffect(() => {
    if (contentList && contentList.success) {
      if (data.type === 'STATIC') {
        contentList?.data.sort((a, b) => {
          let sortingArr = data.content_data
          return sortingArr.indexOf(a.content_id) - sortingArr.indexOf(b.content_id)
        })
      }
      setContentData(contentList.data)
    }
  }, [contentList])

  const handleHoverItems = (name) => {
    // if (!isEdit) return
    setHoverState(name)
  }

  const handleModal = () => {
    setModalState({
      keyID: id,
      modalData: data,
    })
  }

  const handleAddModal = () => {
    onAdd({
      keyID: id,
      modalData: data,
    })
  }

  const getLink = (info) => {
    if (info.video_type === 'PLAYLIST' || info.audio_type === 'PLAYLIST') {
      return `/playlist/${info.content_id}`
    }
    if (info.video_type === 'MPVP' || info.audio_type === 'MPAP') {
      return `/parent-content/${info.content_id}`
    } else {
      if ((playerPageAllowed && info.video_type === 'MPVC') || info.audio_type === 'MPAC') {
        return `/series-watch/${info?.content_id}`
      }
      return `/content/${info.content_id}`
    }
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey]?.data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  return (
    <div
      className={`${isEdit && hoverState && 'component-hover-class'}  relative py-2 xl:py-6 `}
      style={{
        backgroundColor: getStyleValue('component_background', 'primary_color', theme.c1),
      }}
      onMouseOver={() => handleHoverItems(`TOP`)}
      onMouseLeave={() => handleHoverItems('')}
    >
      {isEdit && hoverState.length > 0 && (
        <EditMenu
          onEdit={() => handleModal()}
          onDelete={() => onDelete(id)}
          onCopy={() => onCopy(id)}
          onMoveUp={() => onSwap(id, 'up')}
          onMoveDown={() => onSwap(id, 'down')}
        />
      )}
      <CarouselProvider
        naturalSlideWidth={210}
        naturalSlideHeight={283}
        totalSlides={contentData.length}
        visibleSlides={visibleSlides}
        step={5}
      >
        <div
          className="flex  justify-start items-center"
          style={{
            padding: '0 3.66032%',
          }}
        >
          <p
            style={{
              color: getStyleValue('heading', 'heading_color', '#fff'),
              whiteSpace: 'nowrap',
            }}
            className="xl:text-2xl md:text-xl text-xs font-semibold mb-0"
          >
            {data?.name}
          </p>
          <div
            style={{
              border: `1.5px solid ${getStyleValue('heading', 'line_color', '#fc0001')}`,
            }}
            className="w-full ml-4"
          ></div>
        </div>
        <div
          className={`swimlane-container-dock smooth-horizon-slider-class`}
          style={{
            backgroundColor: getStyleValue('component_background', 'primary_color', theme.c1),
          }}
        >
          <Slider
            style={{
              //   minHeight: isBrowser ? `23rem` : 'unset',
              maxHeight: '490px',
            }}
            className="mt-3"
          >
            {contentData.map((item, index) => {
              return (
                <Slide key={index} index={index} className="">
                  {contentListLoading ? (
                    <LoaderTile height={'100%'} />
                  ) : (
                    <div
                      className="relative cursor-pointer"
                      onMouseOver={() => setHoverIndex(index)}
                      onMouseLeave={() => setHoverIndex('')}
                      onClick={() => customNavigate('DIRECT', getLink(item), isEdit)}
                    >
                      <div
                        style={{
                          opacity: hoverIndex === index ? '1' : '0',
                          padding: '5%',
                          background: '#00000050',
                          transition: 'opacity 0.25s ease-in',
                          zIndex: '20',
                        }}
                        className=" w-full h-full absolute flex justify-center"
                      >
                        <div className=" w-full flex flex-col justify-between">
                          <div>
                            <p
                              style={{
                                color: getStyleValue('card', 'content_title', '#fff'),
                              }}
                              className="mb-0 font-semibold line-clamp-2"
                            >
                              {item.title}
                            </p>
                            <p
                              style={{
                                color: getStyleValue('card', 'content_description', '#d5d5d5'),
                              }}
                              className="mb-0 mt-2 xl:mt-3 text-xs line-clamp-5"
                            >
                              {item.description}
                            </p>
                          </div>
                          <div>
                            {item?.category
                              .filter((e, i) => i < 1)
                              .map((info, idx) => (
                                <p
                                  style={{
                                    color: getStyleValue('card', 'category_text', '#010101'),
                                    background: getStyleValue('card', 'category_bg', '#d6ff05'),
                                  }}
                                  className={` text-[10px] xl:text-[11px] line-clamp-1 w-fit mb-0 px-2 xl:py-1`}
                                  key={idx}
                                >
                                  {info.name}
                                </p>
                              ))}

                            <div
                              style={{
                                background: getStyleValue('card', 'watch_now_bg', '#fa0001'),
                                color: getStyleValue('card', 'watch_now_text', '#fff'),
                                borderRadius: '2px',
                              }}
                              className="font-semibold mt-4 w-full flex justify-center items-center text-sm py-1 cursor-pointer"
                            >
                              Watch Now
                            </div>
                          </div>
                        </div>
                      </div>

                      <CustomImage
                        imageUrl={getTemplateImage(item?.portrait)}
                        imgClass=" w-full"
                        imgStyle={{ zIndex: '-1', aspectRatio: '0.7368421053' }}
                        loaderClass=" w-full"
                        loaderStyle={{ background: '#5A5A5A50', aspectRatio: '0.7368421053' }}
                        imgAlt={'square Img'}
                        errorPlaceholder={PortraitDummyImg}
                      />
                    </div>
                  )}
                </Slide>
              )
            })}
          </Slider>
          {isBrowser && (
            <>
              {contentData.length > visibleSlides ? (
                <ButtonBack className="">
                  <div
                    style={{
                      backgroundColor: getStyleValue(
                        'component_background',
                        'primary_color',
                        theme.c1,
                      ),
                    }}
                    className="kalingo-left-arrow-small flex items-center justify-center"
                  >
                    <img
                      src={KalingoLeftArrow}
                      style={{ height: '37px', marginBottom: '75%' }}
                      alt="KalingoLeftArrow"
                    />
                  </div>
                </ButtonBack>
              ) : null}
              {contentData.length > visibleSlides ? (
                <ButtonNext className="">
                  <div
                    style={{
                      backgroundColor: getStyleValue(
                        'component_background',
                        'primary_color',
                        theme.c1,
                      ),
                    }}
                    className="kalingo-right-arrow-small flex items-center justify-center"
                  >
                    <img
                      src={KalingoRightArrow}
                      style={{ height: '37px', marginBottom: '75%' }}
                      alt="KalingoLeftArrow"
                    />
                  </div>
                </ButtonNext>
              ) : null}
            </>
          )}
        </div>
      </CarouselProvider>
      {isEdit && hoverState.length > 0 && <AddSection openAdd={handleAddModal} />}
    </div>
  )
}

export default withTheme(HoverPeekCarousel)
